const SITE_ROOT = '/credencial-digital';
const CACHE_NAME = 'trabcom-cache-v207';
const current_cache = CACHE_NAME + '_' +
    (new Date()).toLocaleDateString().replaceAll("/", "");
const EXPECTEDS_CACHE = [current_cache];
const urlsToCache = [
    `/${SITE_ROOT}`,
    `/${SITE_ROOT}/js/app-vendors.min.js`,
    `/${SITE_ROOT}/js/app.min.js`,
    `/${SITE_ROOT}/css/style.css`,
    `/${SITE_ROOT}/css/style.css.map`,
    `/${SITE_ROOT}/img/card-192.png`,
];

self.addEventListener('install', function (event: ExtendableEvent) {
    event.waitUntil(async () => {
        const cache = await caches.open(current_cache);
        await cache.addAll(urlsToCache.map(url => new Request(url, {cache: 'reload'})));
        console.log('Serviço Instalado!');
        // caches.open(current_cache)
        //     .then(function (cache) {
        //         return cache.addAll(urlsToCache);
        //     }).then(() => console.log('Serviço Instalado!'))
    });
});


self.addEventListener('activate', (event: ExtendableEvent) => {
    if (navigator.onLine)
        event.waitUntil(async () => {
            const cacheNames = await caches.keys();
            const oldCacheNames = cacheNames.filter(cacheName => !EXPECTEDS_CACHE.includes(cacheName));
            await Promise.all(oldCacheNames.map(cacheName => caches.delete(cacheName)));
            console.log('Serviço Atualizado!');
        });
});

self.addEventListener('fetch', function (event: FetchEvent) {
    event.respondWith(
        caches.match(event.request)
            .then(function (response) {
                if (response) return response;
                return fetch(event.request);
            })
            .then(res => {
                console.log('Serviço Obtido!')
                return res;
            })
    );
});
